import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "./components/Login";
import UserContextProvider from "./context/UserContext";
import RefreshContextProvider from "./context/RefreshContext";
import Locations from "./locations/Locations";
import { Container } from "react-bootstrap";
import { getUserName } from "./backend/RESTUtils";
import Interventii from "./components/Interventii";
import Ascensoare from "./components/Ascensoare";
import Programate from "./components/Programate";
import ProgramateImportante from "./components/ProgramateImportante";
import Revizii from "./components/Revizii";
import Psi from "./components/Psi";
import Interfoane from "./components/Interfoane";
import FisaZilnica from "./components/FisaZilnica";
import Altele from "./components/Altele";
import SediuMasini from "./components/SediuMasini";
import Diverse from "./components/Diverse";
import Finalizate from "./components/Finalizate";
import Setari from "./setari/Setari";
import Pontaje from "./components/Pontaje";
import Administrativ from "./components/Administrativ";
import Notificari from "./components/Notificari";
import Comenzi from "./components/Comenzi";
import Iscir from "./components/Iscir";
import Oferte from "./components/Oferte";
import LeftDashboard from "./components/LeftDashboard";
import Remindere from "./components/Remindere"
import { Row, Col } from "react-bootstrap";
import NewCompanyDomain from "./components/NewCompanyDomain";
import FolderLocatie from "./components/FolderLocatie";
import DocumentSlider from "./components/DocumentSlider";
import About from "./components/About";
import NewMediaViewer from "./components/NewMediaViewer";
import NewMediaSlider from "./components/NewMediaSlider";
import DocumenteLocatieViewer from "./components/DocumenteLocatieViewer";
import OferteCRM from "./components/OferteCRM";
import ClientiCRM from "./components/ClientiCRM";
import SediuMasiniCRM from "./components/SediuMasiniCRM";
import ComenziCRM from "./components/ComenziCRM";
import AdministrativCRM from "./components/AdministrativCRM";
import VideoAccesGE_ERP from "./components/VideoAccessGE_ERP";
import IluminatGE_ERP from "./components/IluminatGE_ERP";
import DocumenteDomeniuFoldereViewer from "./components/DocumenteDomeniuFoldereViewer";
import DocumenteDomeniuViewer from "./components/DocumenteDomeniuViewer";

const PrivateRoute = ({ component: Component, customProps }) => {
  return <Component {...customProps} />;
};

const App = () => {
  return (
    <Container className="black_screen" fluid>
      <BrowserRouter>
        <UserContextProvider>
          <RefreshContextProvider>
            <Row>
              <LeftDashboard domeniu={"interventii"} />
              <Col md={10} className="right_dashboard">
                <Routes>
                  <Route path="/" element={<Login />} />

                  <Route
                    path="/interventii"
                    element={<PrivateRoute component={Interventii} />}
                  />
                  <Route
                    path="/locatii"
                    element={<PrivateRoute component={Locations} />}
                  />
                  <Route
                    path="/psi"
                    element={<PrivateRoute component={Psi} />}
                  />
                  <Route
                    path="/notificari"
                    element={<PrivateRoute component={Notificari} />}
                  />
                  <Route
                    path="/administrativ"
                    element={<PrivateRoute component={Administrativ} />}
                  />
                  <Route
                    path="/programate"
                    element={<PrivateRoute component={Programate} />}
                  />
                  <Route
                    path="/programateImportante"
                    element={<PrivateRoute component={ProgramateImportante} />}
                  />
                  <Route
                    path="/remindere"
                    element={<PrivateRoute component={Remindere} />}
                  />
                  <Route
                    path="/ascensoare"
                    element={<PrivateRoute component={Ascensoare} />}
                  />

                  <Route
                    path="/smartSignage"
                    element={
                      <PrivateRoute
                        component={NewCompanyDomain}
                        customProps={{ locationType: "Smart_Signage" }}
                      />
                    }
                  />
                  <Route
                    path="/software"
                    element={
                      <PrivateRoute
                        component={NewCompanyDomain}
                        customProps={{ locationType: "Software" }}
                      />
                    }
                  />
                  <Route
                    path="/controllers"
                    element={
                      <PrivateRoute
                        component={NewCompanyDomain}
                        customProps={{ locationType: "Controllers" }}
                      />
                    }
                  />
                  <Route
                    path="/personalizariTextile"
                    element={
                      <PrivateRoute
                        component={NewCompanyDomain}
                        customProps={{ locationType: "Personalizari_textile" }}
                      />
                    }
                  />
                  <Route
                    path="/personalizariObiecte"
                    element={
                      <PrivateRoute
                        component={NewCompanyDomain}
                        customProps={{ locationType: "Personalizari_obiecte" }}
                      />
                    }
                  />
                  <Route
                    path="/tiparituri"
                    element={
                      <PrivateRoute
                        component={NewCompanyDomain}
                        customProps={{ locationType: "Tiparituri" }}
                      />
                    }
                  />

                  <Route
                    path="/revizii"
                    element={<PrivateRoute component={Revizii} />}
                  />
                  <Route
                    path="/interfoane"
                    element={<PrivateRoute component={Interfoane} />}
                  />
                  <Route
                    path="/pontaje"
                    element={<PrivateRoute component={Pontaje} />}
                  />
                  <Route
                    path="/fisaZilnica"
                    element={<PrivateRoute component={FisaZilnica} />}
                  />
                  <Route
                    path="/altele"
                    element={<PrivateRoute component={Altele} />}
                  />
                  <Route
                    path="/iscir"
                    element={<PrivateRoute component={Iscir} />}
                  />
                  <Route
                    path="/sediuMasini"
                    element={<PrivateRoute component={SediuMasini} />}
                  />
                  <Route
                    path="/diverse"
                    element={<PrivateRoute component={Diverse} />}
                  />
                  <Route
                    path="/comenzi"
                    element={<PrivateRoute component={Comenzi} />}
                  />
                  <Route
                    path="/oferte"
                    element={<PrivateRoute component={Oferte} />}
                  />
                  <Route
                    path="/istoricLocatie"
                    element={<PrivateRoute component={Finalizate} />}
                  />
                  <Route
                    path="/folderLocatie"
                    element={<PrivateRoute component={FolderLocatie} />}
                  />
                  <Route
                    path="/documentSlider"
                    element={<PrivateRoute component={DocumentSlider} />}
                  />
                  <Route
                    path="/setari"
                    element={<PrivateRoute component={Setari} />}
                  />
                  <Route
                    path="/about"
                    element={<PrivateRoute component={About} />}
                  />
                  <Route
                    path="/newMediaViewer"
                    element={<PrivateRoute component={NewMediaViewer} />}
                  />
                  <Route
                    path="/newMediaSlider"
                    element={<PrivateRoute component={NewMediaSlider} />}
                  />
                  <Route
                    path="/documenteLocatieViewer"
                    element={<PrivateRoute component={DocumenteLocatieViewer} />}
                  />
                   <Route
                    path="/documenteDomeniuFoldereViewer"
                    element={<PrivateRoute component={DocumenteDomeniuFoldereViewer} />}
                  />
                  <Route
                    path="/documenteDomeniuViewer"
                    element={<PrivateRoute component={DocumenteDomeniuViewer} />}
                  />
                  <Route
                    path="/administrativ-crm"
                    element={<PrivateRoute component={AdministrativCRM} />}
                  />
                  <Route
                    path="/oferte-crm"
                    element={<PrivateRoute component={OferteCRM} />}
                  />
                  <Route
                    path="/clienti-crm"
                    element={<PrivateRoute component={ClientiCRM} />}
                  />
                  <Route
                    path="/sediuMasini-crm"
                    element={<PrivateRoute component={SediuMasiniCRM} />}
                  />
                  <Route
                    path="/comenzi-crm"
                    element={<PrivateRoute component={ComenziCRM} />}
                  />
                  <Route
                    path="/video-acces-ge-erp"
                    element={<PrivateRoute component={VideoAccesGE_ERP} />}
                  />
                  <Route
                    path="/iluminat-ge-erp"
                    element={<PrivateRoute component={IluminatGE_ERP} />}
                  />
                </Routes>
              </Col>
            </Row>
          </RefreshContextProvider>
        </UserContextProvider>
      </BrowserRouter>
    </Container>
  );
};

export default App;
